import { useHasAppAccess } from "@arelia-hooks/useHasAppAccess";
import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PATHS } from ".";

interface ConditionalRouteProps {
  children: ReactNode;
}

export function AppAccessRoute({ children }: ConditionalRouteProps) {
  const { hasAccess, loading } = useHasAppAccess();

  if (loading) {
    return <Typography variant="h5" sx={{ margin: "40px" }}>Loading subscription ...</Typography>;
  }

  if (!hasAccess) {
    return <Navigate to={PATHS.SUBSCRIPTION} />;
  }

  return <>{children}</> || null;
}
